/**
 * Bridges the active search tab → the alert button. Holds the alert-scope
 * querystring the active tab's alert currently covers (or null). SearchTabs
 * broadcasts it; JobAlertDialog reads it to decide between "Create alert",
 * "Update alert" (search changed since the alert was made) and "Alert active".
 */
type Listener = (linkedQs: string | null) => void;

let linked: string | null = null;
const listeners = new Set<Listener>();

export function setAlertLink(qs: string | null): void {
  linked = qs;
  for (const l of listeners) l(qs);
}

export function getAlertLink(): string | null {
  return linked;
}

export function subscribeAlertLink(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
